import { Link } from "react-router-dom";

const BUBBLES = [
    { key: "threading", label: "Threading", img: "/services/threading.jpg", aliases: ["threading", "eyebrow", "brow"] },
    { key: "facial", label: "Facial", img: "/services/facial.jpg", aliases: ["facial", "skin", "face"] },
    { key: "waxing", label: "Waxing", img: "/services/waxing.jpg", aliases: ["waxing", "wax"] },
    { key: "hair", label: "Hair", img: "/services/hair.jpg", aliases: ["hair", "haircut", "colour", "color"] },
    { key: "manipedi", label: "Mani & Pedi", img: "/services/manipedi.jpg", aliases: ["mani", "pedi", "manicure", "pedicure", "nail"] },
    { key: "makeup", label: "Makeup", img: "/services/makeup.jpg", aliases: ["makeup", "make up", "make-up", "bridal"] },
];

// Map a ?category= bubble key to the first matching real service category.
export const resolveCategoryParam = (param, categories) => {
    if (!param) return null;
    const p = param.toLowerCase();
    const exact = categories.find((c) => c.toLowerCase() === p);
    if (exact) return exact;
    const aliases = BUBBLES.find((b) => b.key === p)?.aliases || [p];
    for (const a of aliases) {
        const hit = categories.find((c) => c.toLowerCase().includes(a));
        if (hit) return hit;
    }
    return null;
};

export const ServiceBubbles = () => (
    <section className="relative bg-[#FBF6F0] py-16 border-y border-[#C29A5B]/25" data-testid="service-bubbles">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-overline text-center">Our Rituals</div>
            <div className="mt-10 grid grid-cols-3 md:grid-cols-6 gap-x-4 gap-y-10">
                {BUBBLES.map((b, i) => (
                    <Link
                        key={b.key}
                        to={`/book?category=${b.key}`}
                        className="group flex flex-col items-center text-center fade-up"
                        style={{ animationDelay: `${i * 0.08}s` }}
                        data-testid={`service-bubble-${b.key}`}
                    >
                        <div className="relative w-24 h-24 sm:w-32 sm:h-32 lg:w-36 lg:h-36 rounded-full p-[3px] bg-gradient-to-br from-[#E9CC95] via-[#B08544] to-[#7A5228] shadow-[0_14px_30px_-16px_rgba(107,21,53,0.55)] transition-transform duration-300 group-hover:-translate-y-1.5">
                            <img src={b.img} alt={b.label} loading="lazy" className="w-full h-full rounded-full object-cover border-2 border-[#FFFAF6]" />
                            <span className="absolute inset-0 rounded-full ring-0 ring-[#6B1535]/0 transition-[box-shadow] duration-300 group-hover:ring-4 group-hover:ring-[#6B1535]/15" aria-hidden />
                        </div>
                        <div className="mt-4 font-serif-display text-base sm:text-xl uppercase tracking-[0.1em] whitespace-nowrap text-[#3D0C1F] group-hover:text-[#6B1535] transition-colors">{b.label}</div>
                        <div className="text-[#C29A5B] text-xs leading-none mt-1" aria-hidden>♥</div>
                    </Link>
                ))}
            </div>
        </div>
    </section>
);
